<template>
  <v-navigation-drawer
    v-model="drawer"
    :width="400"
    temporary
    floating
    left
    app>
    <v-toolbar color="white" flat dense>
      <v-container>
        <v-layout row wrap>
          <v-flex xs2>
            <v-btn fab bot small class="k-orange-linear-text mx-0" icon flat @click="drawer = false">
              <v-icon small>fas fa-angle-right</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs10 class="text-xs-center" pr-5 pl-2>
            <div class="headline k-orange-linear-text pt-2">
              Filtrar chats
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-toolbar>
    <v-container>
      <!-- <v-layout row wrap mx-3>
        <v-flex xs6 pl-2 v-if="$auth.user().role !== 'agent'">
          <v-text-field
            v-model="filters.agency"
            color="black"
            label="Agencia">
          </v-text-field>
        </v-flex>
      </v-layout> -->
      <v-layout row wrap mx-3>
        <v-flex xs6 pr-2>
          <v-menu
            ref="firstDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            min-width="290px"
            lazy
            offset-y
            full-width>
            <v-text-field
              slot="activator"
              :value="formatDate(filters.minDate, 'YYYY-MM-DD', 'DD/MM/YYYY')"
              color="black"
              label="Desde"
              readonly>
            </v-text-field>
            <v-date-picker
              v-model="filters.minDate"
              @input="$refs.firstDate.save(filters.minDate)"
              locale="es"
              :max="nowIso"
              color="k-orange-linear">
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 pl-2>
          <v-menu
            ref="secondDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            min-width="290px"
            nudge-left="30"
            :left="true"
            lazy
            offset-y
            full-width>
            <v-text-field
              slot="activator"
              :value="formatDate(filters.maxDate, 'YYYY-MM-DD', 'DD/MM/YYYY')"
              color="black"
              label="Hasta"
              readonly>
            </v-text-field>
            <v-date-picker
              v-model="filters.maxDate"
              @input="$refs.secondDate.save(filters.maxDate)"
              locale="es"
              :max="nowIso"
              color="k-orange-linear">
            </v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout row wrap mt-2 ml-3 v-if="tab === '2'">
        <v-flex xs12>
          <v-select
            :items="solvedBy"
            v-model="filters.solvedBy"
            item-text="name"
            item-value="type"
            label="Resuelto por"
            color="black"
            autocomplete
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 text-xs-right>
          <v-btn flat @click="drawer = false">Cerrar</v-btn>
          <v-btn flat @click="clearFilters" v-if="showClear">Restaurar</v-btn>
          <v-btn flat class="k-orange-linear-text" @click="applyFilters()">Aceptar</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-navigation-drawer>
</template>


<script>
import moment from 'moment';
import formatDateMixin from '@/mixins/formatDate';

export default {
  mixins: [
    formatDateMixin,
  ],
  created() {
    this.axios.get('/chat_categories').then(({ data }) => {
      this.solvedBy = data.data;
    });
    moment.locale('es');
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      default: () => {},
    },
    tab: {
      type: String,
      default: '2',
    },
  },
  data() {
    return {
      drawer: false,
      showSolved: true,
      channels: [
        {
          text: 'Canales',
          value: '',
        },
        {
          text: 'Chatbot',
          value: 'chatbot',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Facebook',
          value: 'messenger',
        },
        {
          text: 'Sms',
          value: 'sms',
        },
        {
          text: 'Whatsapp',
          value: 'whatsapp',
        },
      ],
      solvedBy: [],
    };
  },
  computed: {
    showClear() {
      const filters = this.filters;
      return filters.minDate || filters.maxDate;
    },
    nowIso() {
      return moment().toISOString();
    },
  },
  methods: {
    applyFilters() {
      this.$emit('filter');
    },
    clearFilters() {
      this.filters.minDate = '';
      this.filters.maxDate = '';
      this.$emit('clear-filters');
    },
  },
  watch: {
    drawer(newVal) {
      if (!newVal) {
        this.$emit('close');
      }
      setTimeout(() => {
        this.$vuetify.application.left = document.getElementById('main-drawer').style.width.replace(/px/g, '');
      }, 0);
    },
    tab(newVal) {
      if (newVal !== '0') {
        this.filters.solvedBy = '';
      }
    },
    show(newVal) {
      this.drawer = newVal;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/chat_center/Filters.vue